export default __webpack_public_path__ + "static/media/daily-report.519ea2b7.png";